import { useState } from "react";
import { Link } from "react-router-dom";
import arrowIcon from "../../../assets/right-arrow.png";
import favicon from "../../../assets/landingFeatures/nujobsfav.png";
import { Tooltip } from "antd";
function NuJobsSidebar({ sidebarOpen, setSidebarOpen, subscriptionIsActive }) {
  const [isHomeCollapsed, setIsHomeCollapsed] = useState(false);
  const [isCollapsedTeam, setIsCollapsedTeam] = useState(false);
  const [isCollapsedSourcing, setIsCollapsedSourcing] = useState(false);
  const [isCollapsedJD, setIsCollapsedJD] = useState(false);
  const [isCollapsedDashBoard, setIsCollapsedDashBoard] = useState(false);

  const handleToggleCollapseSourcing = () => {
    setIsCollapsedSourcing(!isCollapsedSourcing);
  };
  const handleToggleCollapsejd = () => {
    setIsCollapsedJD(!isCollapsedJD);
  };
  const handleToggleCollapseDashboard = () => {
    setIsCollapsedDashBoard(!isCollapsedDashBoard);
  };
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  return (
    <div>
      <button
        className={`img-toggle ${
          isHomeCollapsed ? "" : "active"
        }`}
        onClick={() => setIsHomeCollapsed(!isHomeCollapsed)}
        data-bs-toggle="collapse"
        data-bs-target="#home-collapse"
        aria-expanded={isHomeCollapsed ? "false" : "true"}
      >
        <img
          src={favicon}
          alt="Arrow"
          width="20"
          height="20"
          className={`arrow-icon me-2 `}
        />
        NuJobs
      </button>

      {!isHomeCollapsed && (
        <div style={{ marginLeft: "10px", marginTop: "10px" }}>

          
          {/* <Link className="sidebar-link" to="/jds">
                Dashboard
            </Link> */}
          {userDetails.productsignon.toLowerCase().includes("qhrflow") ?
          <div>
            <Tooltip
              placement="bottom"
              title={
                subscriptionIsActive ? "" : "Please activate your subscription"
              }
            >
              <button
                className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                  isCollapsedDashBoard ? "" : "active" // Add the active class conditionally
                } sideFont`}
                onClick={subscriptionIsActive ? handleToggleCollapseDashboard : null}
                data-bs-toggle="collapse"
                data-bs-target="#home-collapse"
                aria-expanded={isCollapsedDashBoard ? "false" : "true"}
                style={subscriptionIsActive ? {} : { color: "grey" }}
              >
                <img
                  src={arrowIcon}
                  alt="Arrow"
                  width="8"
                  height="8"
                  className={`arrow-icon me-2 ${isCollapsedDashBoard ? "" : "rotate"}`}
                />
                NuJobs Home
              </button>
            </Tooltip>

            {!isCollapsedDashBoard && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/nujobsemployerdashboard" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Dashboard
                  </Link>
                </li>               
                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>
           :<></>
          }
          {/* <Link className="sidebar-link" to="/jds">
                Dashboard
            </Link> */}
          <div>
            <Tooltip
              placement="bottom"
              title={
                subscriptionIsActive ? "" : "Please activate your subscription"
              }
            >
              <button
                className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                  isCollapsedJD ? "" : "active" // Add the active class conditionally
                } sideFont`}
                onClick={subscriptionIsActive ? handleToggleCollapsejd : null}
                data-bs-toggle="collapse"
                data-bs-target="#home-collapse"
                aria-expanded={isCollapsedJD ? "false" : "true"}
                style={subscriptionIsActive ? {} : { color: "grey" }}
              >
                <img
                  src={arrowIcon}
                  alt="Arrow"
                  width="8"
                  height="8"
                  className={`arrow-icon me-2 ${isCollapsedJD ? "" : "rotate"}`}
                />
                Posted JDs
              </button>
            </Tooltip>

            {!isCollapsedJD && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/nujobposts" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Dashboard
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/nujobsjdAssignments" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Assignments
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/nujobsjdsPriorityInternal" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Internal Priorities
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/nujobsjdsPriority" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Client Priorities
                  </Link>
                </li>     
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/jdseventpage" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Events
                  </Link>
                </li>                             
                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>

          {/* <Link className="sidebar-link" to="/resume_source">
                Resume Sourcing
            </Link> */}
          <div style={{ marginBottom: "60px" }}>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedSourcing ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseSourcing}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedSourcing ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="10"
                height="10"
                className={`arrow-icon me-2 ${
                  isCollapsedSourcing ? "" : "rotate"
                }`}
              />
              Applications
            </button>

            {!isCollapsedSourcing && (
              <ul id="home-collapse" className="">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to="/nujobsapplications"
                    onClick={() => setSidebarOpen(false)}
                  >
                    All
                  </Link>
                </li>

                {/* Add more list items as needed */}
              </ul>
            )}
          </div>
        </div>
      )}
      <hr className="sidebar-hr"></hr>
    </div>
  );
}

export default NuJobsSidebar;
